import React, { useState, useEffect } from 'react';
import {
  Box, Typography, List, ListItem, ListItemText, Avatar, IconButton,
  Divider, useTheme, useMediaQuery, Card
} from '@mui/material';
import { Reorder } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';
import api from '../api/api';
import Sidebar from './Sidebare';

const CandidaturesPage = ({ onReorder }) => {
  const [candidatures, setCandidatures] = useState([]);
  const { user } = useAuth();
  const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('sm'));
  const userId = JSON.parse(localStorage.getItem('user'))?._id;

  useEffect(() => {
    const fetchCandidatures = async () => {
      if (!userId) return;
      try {
        const { data } = await api.get(`/candidatures/${userId}`);
        setCandidatures(data);
      } catch (error) {
        console.error('Erreur de chargement:', error);
      }
    };
    fetchCandidatures();
  }, [userId]);

  const handleMoveUp = (index) => {
    if (index > 0) {
      const updated = [...candidatures];
      [updated[index - 1], updated[index]] = [updated[index], updated[index - 1]];
      setCandidatures(updated);
      onReorder(updated);
    }
  };

  return (
    <Box display="flex" height="100vh">
      {!isSmallScreen && <Sidebar userProfile={user} />}
      <Box flex={1} p={2} display="flex" flexDirection="column" alignItems="center">
        <Card sx={{ maxWidth: 600, width: '100%', boxShadow: 3, mb: 2, p: 2 }}>
          <Typography variant="h4" gutterBottom>Mes Candidatures</Typography>
          {candidatures.length ? (
            <List>
              {candidatures.map(({ id, title, statut, universityId, programId }, index) => (
                <React.Fragment key={id}>
                  <ListItem>
                    <Link to={`/program/${programId}`}>
                      <Avatar src={universityId?.photo} alt={title} style={{margin: '5px'}} />
                    </Link>
                    <ListItemText
                      primary={`${title} | ${statut}`}
                      secondary={`${universityId?.name} | Pays: ${universityId?.address?.country} | Ville: ${universityId?.address?.city}`}
                    />
                    <IconButton onClick={() => handleMoveUp(index)}>
                      <Reorder />
                    </IconButton>
                  </ListItem>
                  <Divider />
                </React.Fragment>
              ))}
            </List>
          ) : (
            <Typography variant="body1" color="textSecondary">
              Aucune candidature enregistrée.
            </Typography>
          )}
        </Card>
      </Box>
    </Box>
  );
};

export default CandidaturesPage;